/* eslint-disable react-native/no-inline-styles */
import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {px} from '../../../utils';
import TimeTableRow from './TimeTableRow';

const TimeTableCol = ({
  items,
  day,
  selectedCards,
  onCardSelect,
  useTimeTablePageStyle,
}) => {
  const selectedFromThisCol =
    selectedCards?.filter((selectedItem) =>
      items.find((item) => item.scheduleId === selectedItem.scheduleId),
    ) || [];
  // const count = onCardSelect ? selectedFromThisCol.length : items.length;

  return (
    <View>
      {/* <TitleRow title={day} type="secondary" containerStyle={styles.title} /> */}
      {useTimeTablePageStyle && (
        <Layout level="3" style={styles.header}>
          <Text style={{fontSize: 16}}>{day}</Text>
        </Layout>
      )}
      <View
        style={
          useTimeTablePageStyle
            ? {flexDirection: 'row', flexWrap: 'wrap'}
            : undefined
        }>
        {items.map((item, index) => (
          <TimeTableRow
            useTimeTablePageStyle={useTimeTablePageStyle}
            isSelected={selectedFromThisCol?.find(
              (selectedItem) => selectedItem.scheduleId === item.scheduleId,
            )}
            disabled={false}
            onSelect={onCardSelect}
            item={item}
            key={index}
            isLastIndex={items.length - 1 === index}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    paddingHorizontal: 0,
  },
  header: {
    marginBottom: px(12),
    paddingHorizontal: px(17),
    paddingVertical: px(7),
  },
});

export default TimeTableCol;
